import { projects } from 'json!../.firebaserc'

export const apiKey = "AIzaSyBuSzNftbHVOOhxirAnQRqOSFIq1V9R09M"
export const projectId = projects.default



// WEBPACK FOOTER //
// ./src/config.js